// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"302":"67a67806","411":"ed38252d","451":"18ac8497","838":"7603efc5","948":"470c8edf"}[chunkId] + ".chunk.js";
};